<template>
  <div class="main-container">
    <!-- <div class="main-header">
      <navigation :title="'设备激活'" :onBack="handleNavigationBack" />
    </div> -->
    <div class="main-content">
      <div class="content-theme">MAXHUB安装码</div>
      <div class="content-description">
        输入【安装码】进行客户信息确认，并获取激活码
      </div>
      <digit-input-box
        @inputChange="handleChange"
        ref="inputCode"
        :maxInputLength="maxInputLength"
        :placeholder="placeholder"
      />
      <div class="verification-result">{{ !codeAuth ? '安装码错误' : '' }}</div>
    </div>
    <div class="main-footer">
      <customize-button
        :content="'安装码激活'"
        :type="handleActive"
        :onClick="handleVerifyCode"
      />
      <div class="link-button" @click="handleEnterForm">无安装码激活</div>
    </div>
    <global-dialog ref="dialog" />
    <div v-if="showMask" class="model_mask"></div>
    <div v-if="showMask" class="mask">
      <div class="mask_title">
        该 MAXHUB 设备只能在中国大陆使用，请手机连接国内网络进行设备激活！
      </div>
      <div class="mask_button" @click="handleClick">确定</div>
    </div>
  </div>
</template>

<script>
import Navigation from '@components/NewComponents/Navigation/Navigation.vue';
import CustomizeButton from '@components/NewComponents/CustomizeButton/CustomizeButton.vue';
import GlobalDialog from '@components/GlobalDialog/GlobalDialog.vue';
import DigitInputBox from './DigitInputBox/DigitInputBox.vue';
import Apis from '@model';
import store from '@stores';
import { cmsService } from '../../../service';
import { trackActiveEvent } from '../../../utils/tools/_track';
export default _extend({
  name: 'Main',
  data() {
    return {
      // 报装码长度
      maxInputLength: 40,
      // 上报的报装码
      reportCode: '',
      // 报装码认证结果
      codeAuth: true,
      showMask: false,
      // 输入框提示
      placeholder: '请输入安装码'
    };
  },
  components: {
    Navigation,
    DigitInputBox,
    CustomizeButton,
    GlobalDialog
  },
  methods: {
    handleNavigationBack() {
      this.$router.back();
    },
    handleChange(value) {
      this.codeAuth = true;

      if (value.length >= 12) {
        this.reportCode = value;
      } else if (value.length < this.maxInputLength) {
        this.reportCode = '';
      }
    },
    handleVerifyCode() {
      this.$refs.dialog.dialogShow(1);
      Apis.postActiveCode(this.reportCode, 2000).then(res => {
        const { result, data, resData } = res;
        if (result === 'success') {
          trackActiveEvent('h5_have_code', this.$pushData);
          // 报装码正确
          this.$refs.dialog.hide();
          this.$store.commit(store.VX_TYPES.FORM.UPDATE_FORM, {
            data,
            resData
          });
          this.$store.commit(store.VX_TYPES.FORM.UPDATE_NO_REPORT_CODE, false);
          this.$refs.inputCode.clear();
          this.reportCode = '';
          this.$router.push(`/v2/ActiveForm/?${window.location.search}`);
        } else if (result === 'fail') {
          // 报装码错误
          this.$refs.dialog.dialogShow(-1);
          this.$refs.dialog.toggle();
          this.$refs.inputCode.toggle('error');
          this.codeAuth = false;
        } else if (result === 'timeout') {
          // 请求超时
          this.$refs.dialog.dialogShow(0);
          this.$refs.dialog.toggle();
        }
      });
    },
    getQueryString(name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    text_jsonp(req) {
      // 创建script的标签
      var script = document.createElement('script');
      // 拼接 url
      // 赋值url
      script.src = req.url;
      // 放入头部
      document.getElementsByTagName('head')[0].appendChild(script);
    },
    async getJsonp() {
      await this.$jsonp('http://ip-api.com/json/', {
        output: 'jsonp'
      })
        .then(data => {
          console.log('data===', data);
          if (data && data.country !== 'China') {
            this.showMask = true;
          } else {
            this.showMask = false;
          }
        })
        .catch(error => {
          console.log('err', error);
        });
    },
    async getIp() {
      // 挂VPN是可以绕过这个IP归属地查询判断的
      try {
        const data = await cmsService.getIP();
        console.log('data:', data);
        if (data && data.country !== 'China') {
          this.showMask = true;
        } else {
          this.showMask = false;
        }
      } catch (error) {
        console.log('error', error.response);
      }
    },
    getActiveParams() {
      const sn = this.getQueryString('sn');
      const pcsn = this.getQueryString('pcsn');
      const masterSn = this.getQueryString('masterSn');
      const opsBrand = this.getQueryString('opsBrand');
      const sign = this.getQueryString('sign');
      const osName = this.getQueryString('osName');
      const opsModel = this.getQueryString('opsModel');
      const opsSn = this.getQueryString('opsSn');
      const masterModel = this.getQueryString('masterModel');
      const masterVersion = this.getQueryString('masterVersion');
      const softwareBrand = this.getQueryString('softwareBrand');
      return {
        sn,
        pcsn,
        masterSn,
        opsBrand,
        masterVersion,
        sign,
        osName,
        opsModel,
        opsSn,
        masterModel,
        softwareBrand
      };
    },
    handleEnterForm() {
      this.$store.commit(store.VX_TYPES.FORM.CLEAR_DATA);
      setTimeout(() => {
        this.$router.push(`/v2/ActiveForm/?${window.location.search}`);
      }, 0);
    },
    handleClick() {
      // this.getIp();
      this.getJsonp();
      this.showMask = false;
    }
  },
  computed: {
    handleActive() {
      if (this.reportCode.length >= 12 && this.codeAuth) {
        return 0;
      } else {
        return -1;
      }
    }
  },
  created() {
    // console.log('ip', this.getIp());
    // const req = {
    //   url: 'http://ip-api.com/json/'
    // };
    // console.log('11', this.text_jsonp(req));
    this.getJsonp();
    const {
      sn,
      pcsn,
      masterSn,
      opsBrand,
      masterVersion,
      sign,
      osName,
      opsModel,
      masterModel,
      opsSn,
      softwareBrand
    } = this.getActiveParams();
    // 判断下 是不是 goodView 是的话直接进去表单填写界面
    // const softwareBrand = this.getQueryString('softwareBrand');
    // console.log(' window.location', location);
    if (softwareBrand && softwareBrand.toLocaleLowerCase() === 'goodview') {
      // window.location.href = window.location.origin + '/v2/ActiveForm/' + window.location.search;
      this.$router.push({
        path: '/v2/ActiveForm',
        query: {
          sn: sn,
          pcsn: pcsn,
          masterSn: masterSn,
          opsBrand: opsBrand,
          masterVersion: masterVersion,
          sign: sign,
          osName: osName,
          opsModel: opsModel,
          masterModel: masterModel,
          opsSn: opsSn,
          softwareBrand: softwareBrand
        }
      });
    }
  }
});
</script>

<style lang="scss">
@import './Main';
</style>



// WEBPACK FOOTER //
// src/business/views/Main/Main.vue